// src/pages/About.jsx
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../style.css";
import "../components/About.css";
import { Link } from "react-router-dom";

const pub = process.env.PUBLIC_URL;

export default function About() {

  
/* ─────────────── CLIENT LOGOS — AUTO-SCROLL MARQUEE ─────────────── */
function Clients() {
  const pub = process.env.PUBLIC_URL;

  // Wire-up to generated files in /public/clients/client-01..09
  const items = [
    { name: "Client 01", slug: "client-01", url: "#" },
    { name: "Client 02", slug: "client-02", url: "#" },
    { name: "Client 04", slug: "client-04", url: "#" },
    { name: "Client 05", slug: "client-05", url: "#" },
    { name: "Client 06", slug: "client-06", url: "#" },
    { name: "Client 07", slug: "client-07", url: "#" },
    { name: "Client 08", slug: "client-08", url: "#" },
    { name: "Client 09", slug: "client-09", url: "#" },
  ].map(({ name, slug, url }) => ({
    name,
    url,
    gray:  `${pub}/clients/${slug}/gray/128.png`,
    color: `${pub}/clients/${slug}/color/128.png`,
  }));

  // Duplicate for seamless loop
  const track = [...items, ...items];

  return (
    <section className="clients marquee" id="clients">
      {/* Scoped styles for drop-in */}
      <style>{`
        .clients.marquee { padding: 3rem 0; background:#fff; }
        .clients.marquee .heading { text-transform:none; margin:0 0 1rem; text-align:center; }

        .marquee-viewport {
          --scroll-speed: 45s;   /* increase for slower scroll */
          --gap: 48px;
          overflow: hidden;
          position: relative;
          width: 100%;
          padding: .5rem 0;
        }
        .marquee-track {
          display: flex;
          align-items: center;
          gap: var(--gap);
          list-style: none;
          padding: 0;
          margin: 0;
          width: max-content;
          animation: marquee-slide var(--scroll-speed) linear infinite;
        }
        /* left -> right */
        @keyframes marquee-slide {
          from { transform: translateX(-50%); }
          to   { transform: translateX(0%); }
        }
        .marquee-item a {
          position: relative;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          height: 72px;
          padding: 4px 8px;
        }
        .marquee-item .logo {
          height: 64px;
          max-width: 180px;
          width: auto;
          object-fit: contain;
          transition: opacity .25s ease;
          display: block;
        }
        .marquee-item .color { position: absolute; inset: 4px 8px; opacity: 0; }
        .marquee-item .gray  { opacity: .75; filter: grayscale(100%); }
        .marquee-item:hover .gray  { opacity: 0; }
        .marquee-item:hover .color { opacity: 1; }

        .marquee-viewport:hover .marquee-track { animation-play-state: paused; }

        @media (max-width: 640px) {
          .marquee-viewport { --scroll-speed: 55s; --gap: 28px; }
          .marquee-item .logo { height: 56px; max-width: 150px; }
          .marquee-item a { height: 64px; }
        }
        @media (prefers-reduced-motion: reduce) {
          .marquee-track { animation: none; }
        }
      `}</style>

      <h1 className="heading">trusted by leading clients</h1>

      <div className="marquee-viewport">
        <ul className="marquee-track" aria-label="Client logos (scrolling)">
          {track.map((c, i) => (
            <li key={i} className="marquee-item">
              <a href={c.url} aria-label={`Visit ${c.name}`} title={c.name}>
                <img
                  className="logo gray"
                  src={c.gray}
                  alt={c.name}
                  height="64"
                  loading="lazy"
                  decoding="async"
                />
                <img
                  className="logo color"
                  src={c.color}
                  alt=""
                  height="64"
                  loading="lazy"
                  decoding="async"
                  aria-hidden="true"
                />
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
  /* ─────────── initialise AOS + scroll utilities ─────────── */
  useEffect(() => {
    AOS.init({ duration: 700, once: false, delay: 50 });

    const loader = document.querySelector(".loader");
    if (loader) {
      loader.classList.add("fade-out");
      setTimeout(() => (loader.style.display = "none"), 500);
    }

    const progressBar = document.getElementById("progressBar");
    const backToTop = document.getElementById("backToTop");

    const onScroll = () => {
      if (progressBar) {
        const winScroll = document.documentElement.scrollTop;
        const height =
          document.documentElement.scrollHeight -
          document.documentElement.clientHeight;
        progressBar.style.width = (winScroll / height) * 100 + "%";
      }
      if (backToTop) {
        backToTop.classList.toggle("visible", window.scrollY > 100);
      }
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const YEARS_EXPERIENCE = new Date().getFullYear() - 2002; // 23 in 2025
  const leadershipMembers = [
    {
      img: "team/mosike-matsimela.png",
      name: "Mosike Matsimela",
      role: "CEO",
    },
    {
      img: "team/peter-matsimela.png",
      name: "Peter Matsimela",
      role: "Construction Manager",
    },
  ];
  const teamMembers = [
    {
      img: "team/sipho-tlou.png",
      name: "Sipho Tlou",
      role: "Artisan Assistant",
    },
    {
      img: "team/james-baloyi.png",
      name: "James Baloyi",
      role: "Electrician / Supervisor",
    },
    {
      img: "team/mahlatse-mashapo.png",
      name: "Mahlatse Mashapo",
      role: "Artisan Assistant",
    },
    {
      img: "team/sello-matsimela.png",
      name: "Sello Matsimela",
      role: "Electrician / Foreman",
    },
  ];
  const workShowcase = [
    {
      type: "video",
      media: "vid1.mp4",
      title: "On-Site Delivery",
      description:
        "Real footage from active project work carried out by our team on site.",
      tag: "Field Footage",
    },
    {
      type: "video",
      media: "vid2.mp4",
      title: "Installation Progress",
      description:
        "A quick look at live installation activity and day-to-day site execution.",
      tag: "Live Site Work",
    },
    {
      type: "video",
      media: "vid3.mp4",
      title: "Team in Action",
      description:
        "Hands-on project footage showing our crew at work in real conditions.",
      tag: "Crew Operations",
    },
    {
      type: "video",
      media: "vid4.mp4",
      title: "Project Execution",
      description:
        "Live project activity that reflects the practical electrical services we deliver.",
      tag: "Electrical Work",
    },
    {
      type: "video",
      media: "vid5.mp4",
      title: "Workmanship Close-Up",
      description:
        "Another view of the quality, pace and site presence behind our delivery.",
      tag: "Active Project",
    },
  ];

  return (
    <>
      {/* ─────────── loader + scroll bar ─────────── */}
      <div className="progress-container">
        <div id="progressBar" className="progress-bar" />
      </div>
      <div className="loader">
        <div className="electric-loader" />
      </div>

      {/* ─────────── quick-contact sidebar ─────────── */}
      <div className="contact-info">
        <div id="close-contact-info" className="fas fa-times" />

        <div className="info">
          <i className="fas fa-phone" />
          <h3>Phone Number</h3>
          <p>+27&nbsp;82&nbsp;498&nbsp;9477</p>
        </div>

        <div className="info">
          <i className="fas fa-envelope" />
          <h3>Email Address</h3>
          <p>info@mosikeelectrical.com</p>
        </div>

        <div className="info">
          <i className="fas fa-map-marker-alt" />
          <h3>Office Address</h3>
          <p>59A Kirkness Road, The Orchards&nbsp;X10&nbsp;0182</p>
          <a
            href="https://maps.google.com/?q=59A+Kirkness+Road+0182"
            target="_blank"
            rel="noreferrer"
            className="btn"
            style={{ marginTop: 10 }}
          >
            <i className="fas fa-map-marked-alt" /> Get Directions
          </a>
        </div>

        {/* accessible social links */}
        <div className="share">

            <span className="sr-only">Facebook</span>
         
          <a
            href="https://www.linkedin.com/company/mosike-electrical-contractors/"
            target="_blank"
            rel="noreferrer"
            aria-label="LinkedIn"
            className="fab fa-linkedin"
          >
            <span className="sr-only">LinkedIn</span>
          </a>
        </div>
      </div>

      {/* ─────────── about hero ─────────── */}
      <section className="about" id="about">
        <div data-aos="fade-up">
          <h1 className="section-title">About Mosike Electrical Contractors</h1>
          <p className="section-description">
            Your trusted partner for comprehensive electrical solutions—driven
            by quality, safety, and customer satisfaction since&nbsp;2002.
          </p>
        </div>

        <div className="row" style={{ marginTop: "1rem" }}>
          <div className="video" data-aos="fade-right" data-aos-delay="100">
            <video
              src={`${pub}/Circut.mp4`}
              loop
              muted
              autoPlay
              playsInline
            />
          </div>

          <div
            className="content about-hero-content"
            data-aos="fade-left"
            data-aos-delay="200"
          >
            <h3>We provide the high-quality work you envision</h3>
            <p>
              Established in&nbsp;2002, Mosike Electrical Contractors (M.E.C.)
              is a 100&nbsp;% black-owned, black-directed enterprise
              specialising in electrical design, automation installation and
              maintenance of low-, medium- and high-voltage equipment. Our
              certified electricians deliver innovative, energy-efficient
              solutions on projects of every size.
            </p>
            <Link to="/services" className="btn">
              Our Services <i className="fas fa-chevron-right" />
            </Link>
          </div>
        </div>

        {/* key stats */}
        <div className="box-container" data-aos="fade-up" data-aos-delay="100">
          <div className="box">
            <h3>{YEARS_EXPERIENCE}+</h3>
            <p>Years of Experience</p>
          </div>
          <div className="box">
            <h3>400+</h3>
            <p>Projects Completed</p>
          </div>
          <div className="box">
            <h3>100+</h3>
            <p>Satisfied Clients</p>
          </div>
          <div className="box">
            <h3>11</h3>
            <p>Skilled Team Members</p>
          </div>
        </div>
      </section>

      {/* ─────────── core services ─────────── */}
      <section className="service-icons-section" data-aos="fade-up">
        <h2 className="section-title">Our Core Service Areas</h2>
        <p className="section-description">
          Electrical installations, generator solutions, automation and more.
        </p>

        <div className="service-icons">
          {[
            { icon: "home", label: "Residential" },
            { icon: "building", label: "Commercial" },
            { icon: "industry", label: "Industrial" },
            { icon: "tools", label: "Maintenance" },
          ].map((s, index) => (
            <div
              key={s.label}
              className="service-icon"
              data-aos="zoom-in"
              data-aos-delay={100 + index * 100}
            >
              <i className={`fas fa-${s.icon}`} />
              <h4>{s.label}</h4>
            </div>
          ))}
        </div>
      </section>

      {/* ─────────── work showcase ─────────── */}
      <section className="work-showcase-section" data-aos="fade-up">
        <h2 className="section-title">Our Work In Action</h2>
        <p className="section-description">
          A quick look at the kind of practical, on-site electrical work we
          deliver for homes, businesses and industrial clients.
        </p>

        <div className="work-showcase-grid">
          {workShowcase.map((item, index) => (
            <article
              key={item.title}
              className={`work-showcase-card${
                item.featured ? " work-showcase-card-featured" : ""
              }`}
              data-aos="fade-up"
              data-aos-delay={100 + index * 80}
            >
              <div className="work-showcase-media-wrap">
                {item.type === "video" ? (
                  <video
                    src={`${pub}/${item.media}`}
                    className="work-showcase-media"
                    controls
                    muted
                    playsInline
                    preload="metadata"
                  />
                ) : (
                  <img
                    src={`${pub}/${item.media}`}
                    alt={item.title}
                    className="work-showcase-media"
                  />
                )}
              </div>

              <div className="work-showcase-content">
                <span className="work-showcase-tag">{item.tag}</span>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="work-showcase-cta">
          <Link to="/projects" className="btn">
            View More Projects <i className="fas fa-chevron-right" />
          </Link>
        </div>
      </section>

      {/* ─────────── team ─────────── */}
      <section className="team-section-wrapper" data-aos="fade-up">
        <h2 className="section-title">Our Expert Team</h2>
        <p className="section-description">
          Meet the people behind Mosike Electrical Contractors, with roles and
          portraits matched to your approved team reference.
        </p>

        <div className="leadership-grid">
          {leadershipMembers.map((m, index) => (
            <div
              key={m.name}
              className="member member-card"
              data-aos="fade-up"
              data-aos-delay={100 + index * 100}
            >
              <img
                src={`${pub}/${m.img}`}
                alt={m.name}
                className="member-photo"
              />
              <div className="member-info">
                <h3>{m.name}</h3>
                <span className="member-role">{m.role}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="team-members">
          {teamMembers.map((m, index) => (
            <div
              key={m.name}
              className="member member-card"
              data-aos="fade-up"
              data-aos-delay={100 + index * 100}
            >
              <img
                src={`${pub}/${m.img}`}
                alt={m.name}
                className="member-photo"
              />
              <div className="member-info">
                <h3>{m.name}</h3>
                <span className="member-role">{m.role}</span>
              </div>
            </div>
          ))}
        </div>
      </section>
            {/* ───── CLIENTS (MARQUEE) ───── */}
      <Clients />

      {/* ─────────── testimonials ─────────── */}
      <section className="testimonials-section" data-aos="fade-up">
        <h2 className="section-title">What Our Clients Say</h2>
        <p className="section-description">
          Hear directly from those who’ve experienced the M.E.C. difference.
        </p>

        <div className="testimonials-grid">
          {[
            {
              quote:
                "Mosike Electrical Contractors completely rewired our 1950s home. Professional, thorough and safety-minded—we feel much safer now.",
              author: "Linda&nbsp;B. – Homeowner",
            },
            {
              quote:
                "Our go-to team for multiple commercial builds; always top-quality workmanship and on schedule.",
              author: "Martin&nbsp;K. – Developer",
            },
          ].map((t, index) => (
            <div
              key={t.author}
              className="testimonial"
              data-aos="fade-up"
              data-aos-delay={100 + index * 100}
            >
              <p>{`"${t.quote}"`}</p>
              <strong dangerouslySetInnerHTML={{ __html: t.author }} />
            </div>
          ))}
        </div>
      </section>

      {/* ─────────── call-to-action ─────────── */}
      <section className="cta-section" data-aos="fade-up">
        <div className="cta-content">
          <h2>Ready to Start Your Electrical Project?</h2>
          <p>
            From new installations to routine maintenance, our team is here to
            help. Contact us for a consultation or quote today.
          </p>
          <div className="cta-buttons">
            <a href="tel:+27824989477" className="btn btn-white">
              <i className="fas fa-phone" /> Call&nbsp;(+27)&nbsp;82&nbsp;498&nbsp;9477
            </a>
            <Link to="/contact" className="btn btn-outline">
              <i className="fas fa-envelope" /> Request a Quote
            </Link>
          </div>
        </div>
      </section>

      {/* ─────────── back-to-top ─────────── */}
      <div
        className="back-to-top"
        id="backToTop"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        <i className="fas fa-arrow-up" />
      </div>
    </>
  );
}
